import ryne from './images/ryneprofile.JPG';
import chandra from './images/chandraprofile.JPG';
import mccall from './images/mccallprofile.JPG';
import paige from './images/paigeprofile.JPG';
import cheryl from './images/cherylprofile.jpeg';
import mary from './images/maryprofile.JPG';

export const providerImages = {
  'Ryne Evans': ryne,
  'Chandra Lindeman': chandra,
  'McCall Evans': mccall,
  'Paige Butkey': paige,
  'Cheryl Snider': cheryl,
  'Mary Baja': mary,
}